export const tables = {
  compass: {
    codes: {
    "9XX": 100,
    "9XZ": 100,
    },
    parameters: {
      min: null,
      max: null
    },
    one_minute: {
      codes: {
        "9XX": 100,
        "9XZ": 100,
        //Codice tabella OCS -> cambia quando cambiano quelle sopra;
        "9XX_CODE": "5MB",
      },
      parameters: {
        min: null,
        max: null
      },
    },
    endpointOrigin: ``,
  }
};